/* =============================================================================
 * M.M.LaFleur — place the True Fit widget in the buy column.
 *
 * True Fit's guide asks for its div to sit "just above or below your size
 * selector". That is inside sections/mm_product.liquid, which is ~70KB with no
 * patch operation on the Admin API — every edit retransmits the whole file.
 *
 * So the div is RENDERED where Liquid can cheaply reach it (the first gallery
 * frame, in mm_product_media.liquid, which is the same seam the sale label and
 * the PDP stylesheet already use) and MOVED here, once, to sit above the SIZE
 * block. Same pattern as mm-pdp-sale-label.js, and for the same reason.
 *
 * WHY THE DIV IS RENDERED IN LIQUID RATHER THAN BUILT HERE
 * -------------------------------------------------------
 * It carries three values only Liquid knows: the product id, the locale pair,
 * and the logged-in customer id. Building the element in JavaScript would mean
 * publishing all three into a global for this file to read — more moving parts,
 * and the id would be a second copy of something the page already states.
 *
 * WHY calculate() IS CALLED AFTER MOVING
 * --------------------------------------
 * True Fit scans for .tfc-fitrec-product when its library loads. If that scan
 * happens before the move, or the colourway swap re-renders the buy column
 * underneath it, the widget is left pointing at an element no longer in the
 * tree and silently renders nothing. tfcapi('calculate') asks it to look again.
 * The call is queued by the stub in the head snippet, so it is safe to make
 * before the library itself has finished loading.
 *
 * SPACING (Sept 2026)
 * -------------------
 * The button needs its own space: flush against the price or the colour row
 * (whose selected ring is a 3px box-shadow that overhangs its box) it looked
 * cramped and the ring overlapped it. But that space must only exist when the
 * button does. True Fit fills the div with its own markup even when it decides
 * not to show a button, so a CSS :empty test is not enough — the div was
 * "not empty" while showing nothing, and the added margins pushed SIZE down.
 *
 * So the decision is made on what is actually drawn: the div's rendered
 * height, watched with a ResizeObserver. Taller than a few pixels, it gets
 * data-mm-tf="shown" and the spacing; otherwise it carries no margins and SIZE
 * sits at its normal distance, exactly as if True Fit were not installed.
 *
 * THE 24-48 HOUR CAVEAT: True Fit normalises the catalogue after install and
 * the widget does not appear until that finishes. An empty div on the PDP in
 * the meantime is expected, not a placement bug.
 * ========================================================================== */

(function () {
  "use strict";

  if (window.__mmTrueFitBound) return;
  window.__mmTrueFitBound = true;

  var GAP = "1.5rem";
  var MIN_VISIBLE_PX = 4;

  var CSS =
    /* Resting state: occupies nothing, adds nothing. SIZE keeps its own
       margin from mm-shop.css / mm-pdp-space.css untouched. */
    ".mm-scope .mm-pdp-info .tfc-fitrec-product{display:block;clear:both;margin:0;padding:0;line-height:normal}" +
    ".mm-scope .mm-pdp-info .tfc-fitrec-product > *{max-width:100%}" +
    /* Button actually drawn: even space above it and between it and SIZE.
       (0,4,0) and (0,5,0) clear .mm-pdp-block in both stylesheets. */
    ".mm-scope .mm-pdp-info .tfc-fitrec-product[data-mm-tf=\"shown\"]{margin-top:" + GAP + "}" +
    ".mm-scope .mm-pdp-info .tfc-fitrec-product[data-mm-tf=\"shown\"] + .mm-pdp-block{margin-top:" + GAP + "}";

  function ensureCss() {
    if (document.getElementById("mm-truefit-css")) return;
    var style = document.createElement("style");
    style.id = "mm-truefit-css";
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  /* Height of the div's own content box. Margins are excluded by
     getBoundingClientRect, so toggling them cannot feed back into this. */
  function sync(widget) {
    var shown = widget.getBoundingClientRect().height > MIN_VISIBLE_PX;
    var current = widget.getAttribute("data-mm-tf") === "shown";
    if (shown === current) return;
    if (shown) {
      widget.setAttribute("data-mm-tf", "shown");
    } else {
      widget.removeAttribute("data-mm-tf");
    }
  }

  function watch(widget) {
    if (widget.__mmTfWatched) return;
    widget.__mmTfWatched = true;
    sync(widget);
    if (typeof window.ResizeObserver === "function") {
      new ResizeObserver(function () { sync(widget); }).observe(widget);
    }
  }

  function recalc() {
    if (typeof window.tfcapi === "function") window.tfcapi("calculate");
  }

  function place() {
    var widget = document.querySelector(".tfc-fitrec-product");
    if (!widget) return;

    var sizes = document.querySelector(".mm-pdp-sizes");
    if (!sizes) return;

    ensureCss();

    /* The size grid's own block, so the widget lands between the colourway row
       and SIZE rather than between the SIZE heading and its chips. */
    var block = sizes.closest(".mm-pdp-block") || sizes;
    if (!block.parentNode) return;

    /* Already in position — and this check is what stops the observer below
       from reacting to its own move. Still re-check what is drawn, since True
       Fit fills the div in after the move. */
    if (widget.nextElementSibling === block) {
      watch(widget);
      sync(widget);
      return;
    }

    block.parentNode.insertBefore(widget, block);
    watch(widget);
    recalc();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", place);
  } else {
    place();
  }

  /* Barba replaces <main> without firing an event this can listen for, and a
     colourway swap re-renders the buy column in place. Both land here. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = window.requestAnimationFrame(function () {
        pending = null;
        place();
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
}());
